module.exports = __webpack_public_path__ + "static/media/close-reading-logo-text.ba62bf7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/close-reading-logo-text.svg
// module id = 1185
// module chunks = 0